<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('platformCollection.collection_stage')">
              <a-select v-model="queryParam.configId" allowClear>
                <a-select-option v-for="item in normalConfigList" :key="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{
                $t('reset')
              }}</a-button>
              <a-button type="primary" @click="submitLoanCountData" icon="check" style="margin-left: 8px">{{
                $t('confirm')
              }}</a-button>
            </span>
          </a-col>
        </a-row>

        <a-row :gutter="12" style="margin: 20px 0px">
          <p class="description d_high_light">
            {{ $t('platformCollection.un_settled_count') }}{{ unSettledCount || 0 }}
          </p>
        </a-row>
      </a-form>
    </div>
    <a-table
      ref="table"
      rowKey="id"
      size="middle"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="false"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="loanCount" slot-scope="text, record">
        <div style="text-align: center; width: 100%">
          <a-input
            v-model="record.loanCount"
            style="width: 90%; display: inline-block; text-align: center"
            @change="handleLoanCountChange(record)"
            placeholder="0"
          />
        </div>
      </template>
    </a-table>
    <!-- <div style="margin-top: 15px; text-align: right">
      <v-pagination
        v-if="total"
        :page-num="form.pageNum"
        :page-size="form.pageSize"
        :total="total"
        @change="handleTableChange"
      />
    </div> -->
    <a-modal :title="modalTitle" v-model="visible" @ok="submitScheduling">
      <a-form :form="basicForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-item :label="$t('platformCollection.loan_count')">
          <a-input :placeholder="$t('platformCollection.enter_loan_count')" v-model="basicForm.loanCount"></a-input>
        </a-form-item>

        <a-form-item :label="$t('platformCollection.on_duty')">
          <a-switch v-model="basicForm.status" />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-drawer
      :title="$t('platformCollection.management')"
      placement="right"
      :visible="drawerVisible"
      :group-id="currentGroupId"
      width="640"
      @close="closeDrawer"
    >
      <edit-group v-if="drawerVisible" :group-id="currentGroupId" />
    </a-drawer>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getHeaders } from '@/utils/request'
import moment from 'moment'
import vPagination from '../modules/pagination'
import {
  getCollectionManualUserSchedule,
  getUnSettledCount,
  insertOrUpdateCollectionScheduling,
} from '@/webpublicapi/collection'
import { getSysGroup } from '@/webpublicapi/platformCollection'
import { getAllNormalConfig } from '@/webpublicapi/normalConfig'
import { getColUserList } from '@/api/system'

// 提交接口（请替换为实际接口）
import { submitLoanCountList } from '@/webpublicapi/collection'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.',
}
export default {
  name: 'CollectionUserSchedule',
  components: {
    vPagination,
  },
  data() {
    return {
      visible: false,
      drawerVisible: false,
      modalTitle: this.$t('add'),
      currentGroupId: undefined,
      CollectorNameList: [],
      groupList: [],
      departmentList: [],
      normalConfigList: [],
      userIdList: [],
      groupListFrom: [],
      departmentListFrom: [],
      total: 0,
      unSettledCount: null,
      openFileDialogOnClick: false,
      uploadDataParam: {},
      queryParam: {
        configId: undefined, //组
        userId: undefined,
      },
      dataSource: [],
      loading: false,
      form: {
        pageNum: 1,
        pageSize: 10,
        keywords: undefined,
        groupIdP: '',
      },
      defaultBasicForm: {
        id: undefined,
        date: moment().add(1, 'days'),
        departmentId: undefined,
        groupId: undefined,
        groupIdShow: undefined,
        userId: undefined,
        configId: undefined,
        status: true,
      },
      basicForm: {},
      // 存储接口返回的原始数据（用于提交时原封不动携带）
      originalDataSource: [],
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '催收员',
          align: 'center',
          dataIndex: 'userName',
          width: '18%',
        },
        {
          title: '催收员账号',
          align: 'center',
          dataIndex: 'loginName',
          width: '18%',
        },
        {
          title: '催收阶段',
          align: 'center',
          dataIndex: 'configName',
          width: '18%',
        },
        {
          title: '组名',
          align: 'center',
          dataIndex: 'groupName',
          width: '18%',
        },
        {
          title: '部门名',
          align: 'center',
          dataIndex: 'departmentName',
          width: '18%',
        },
        {
          title: this.$t('platformCollection.loan_count'),
          align: 'center',
          dataIndex: 'loanCount',
          width: '10%',
          scopedSlots: { customRender: 'loanCount' },
        },
      ]
    },
  },
  created() {
    // 移除created中的loadData调用，改为查询时加载
    getAllNormalConfig().then((res) => {
      this.normalConfigList = res.data || []
    })
  },

  methods: {
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.search()
    },

    // 校验是否为非负整数（允许0）
    isNonNegativeInteger(value) {
      if (value === '' || value === undefined || value === null) return true
      const reg = /^[0-9]\d*$/
      return reg.test(value)
    },

    // 处理分担数量修改（确保是字符串格式）
    handleLoanCountChange(record) {
      if (record.loanCount) {
        // 强制转为字符串并去空格
        record.loanCount = String(record.loanCount).trim()
      }
    },

    // 提交：原封不动携带原始数据 + 正确的loanCount
    submitLoanCountData() {
      // 1. 校验所有loanCount
      let hasError = false
      this.dataSource.forEach((item) => {
        if (!this.isNonNegativeInteger(item.loanCount)) {
          hasError = true
        }
      })
      if (hasError) {
        this.$message.error('请输入整数')
        return
      }

      // 2. 组装提交数据：原始数据 + 编辑后的loanCount（确保字段一一对应）
      const submitData = this.dataSource.map((item) => {
        // 找到对应的原始数据项
        const originalItem = this.originalDataSource.find((ori) => ori.id === item.id)
        // 处理loanCount（空值转0，确保是字符串）
        const loanCount = item.loanCount?.trim() || '0'

        // 合并原始数据和编辑后的loanCount（原始数据优先级低，避免覆盖编辑值）
        return {
          ...originalItem,
          ...item,
          loanCount: loanCount,
        }
      })

      // 3. 过滤掉loanCount=0的记录
      const filteredSubmitData = submitData.filter((item) => {
        const count = Number(item.loanCount)
        return count !== 0
      })

      // 4. 计算过滤后所有loanCount的总和
      const totalLoanCount = filteredSubmitData.reduce((sum, item) => {
        return sum + Number(item.loanCount)
      }, 0)

      // 5. 校验总和是否等于未结清订单数量
      if (totalLoanCount !== Number(this.unSettledCount)) {
        this.$message.error(`分担总量(${totalLoanCount})不等于未结清订单数量(${this.unSettledCount})`)
        return
      }

      // 6. 调用接口提交

      const requestParams = {
        paramList: filteredSubmitData,
        totalCount: this.unSettledCount,
      }
      this.loading = true
      submitLoanCountList(requestParams)
        .then((res) => {
          if (res.code === 1000) {
            this.$message.success('提交成功')
            this.search() // 提交后重新查询最新数据
          } else {
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          this.$message.error(e.message)
        })
    },

    // 查询数据（统一入口）
    search() {
      this.loading = true
      const params = this.getQueryParams()
      getCollectionManualUserSchedule(params)
        .then((res) => {
          if (res.code === 1000) {
            this.total = res.data.total
            // 深拷贝原始数据（保留所有字段）
            this.originalDataSource = JSON.parse(JSON.stringify(res.data.list))
            // 初始化dataSource：给每个项添加loanCount字段（默认空字符串）
            this.dataSource = res.data.list.map((item) => ({
              ...item,
              loanCount: item.loanCount ? String(item.loanCount) : '', // 确保是字符串
            }))
          } else {
            this.total = 0
            this.dataSource = []
            this.originalDataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          this.$message.error(e.message)
        })
      // 查询未结清数量
      getUnSettledCount(params)
        .then((res) => {
          if (res.code === 1000) {
            this.unSettledCount = res.data.totalCount
          } else {
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          this.$message.error(e.message)
        })
    },

    onChangeOne(value) {
      getSysGroup({ departmentId: value }).then((res) => {
        this.groupList = res.data || []
        this.queryParam.groupId = ''
      })
    },

    onChangeDepartment(value) {
      this.basicForm.groupId = undefined
      this.basicForm.userId = undefined
      this.basicForm.configIdShow = undefined
      this.basicForm.configId = undefined
      this.groupListFrom = []
      this.userIdList = []

      getSysGroup({ departmentId: value }).then((res) => {
        this.groupListFrom = res.data || []
        if (this.groupListFrom.length === 0) return

        for (let group of this.groupListFrom) {
          group.label = group.groupName
          group.value = group.id
        }
      })
    },

    onChangeGroup(value) {
      this.basicForm.configIdShow = undefined
      this.basicForm.configId = undefined
      if (value) {
        let configId
        for (let group of this.groupListFrom) {
          if (group.value === value) {
            configId = group.collectionLevel
            break
          }
        }
        for (let config of this.normalConfigList) {
          if (config.id === parseInt(configId)) {
            this.basicForm.configIdShow = config.name
            this.basicForm.configId = config.id
            break
          }
        }
      }

      this.userIdList = []
      this.basicForm.userId = undefined

      let searchFrom = { pageNum: 1, pageSize: 1000, userstatus: '1' }
      if (this.basicForm.groupId) searchFrom.groupIdP = this.basicForm.groupId
      else return

      getColUserList(searchFrom).then((res) => {
        this.userIdList = res.data ? res.data.rows || [] : []
        if (this.userIdList.length === 0) return

        for (let user of this.userIdList) {
          user.label = user.userName
          user.value = user.id
        }
      })
    },

    getHeaders() {
      return getHeaders()
    },

    clickUploadFile() {},

    // 查询按钮触发
    searchQuery() {
      //this.form.pageNum = 1 // 重置页码
      this.search()
    },

    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },

    // 废弃旧的loadData，统一用search
    loadData(arg) {
      this.search()
    },

    getQueryParams() {
      const data = { ...this.queryParam }
      let param = this.queryParam
      for (const group of this.groupList) {
        if (group.id === param.groupId) param.groupName = group.groupName
      }
      param = Object.assign(data)
      param.pageNum = this.form.pageNum
      param.pageSize = this.form.pageSize
      return filterObj(param)
    },

    // 重置查询条件
    searchReset() {
      this.queryParam.configId = undefined
      this.form.pageNum = 1
    },

    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },

    handleChangeUpload(info) {
      console.log(info)
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        console.log('上传成功！')
        if (info.file.response.code === 1000) {
          this.$message.success(`${info.file.name} file uploaded successfully`)
        } else {
          alert(info.file.response.msg)
        }
      } else if (info.file.status === 'error') {
        alert('system error!')
      }
      this.search()
    },

    createScheduling(mode, record = {}) {
      this.changeModal(true)
      this.basicForm.id = record.id
      this.basicForm = { ...this.defaultBasicForm }
      this.modalTitle = mode == 'add' ? this.$t('add') : this.$t('edit')
    },

    submitScheduling() {
      this.changeModal(false)
      this.loading = true
      const form = {
        ...this.basicForm,
        status: this.basicForm.status ? 1 : 0,
        dateStr: this.basicForm.date ? this.transformTime(this.basicForm.date) : undefined,
        date: undefined,
      }
      insertOrUpdateCollectionScheduling(form)
        .then((res) => {
          if (res.code === 1000) {
            this.$message.success('操作成功')
            this.search()
          } else {
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          this.$message.error(e.message)
        })
    },

    closeDrawer() {
      this.drawerVisible = false
    },

    changeModal(visible) {
      this.visible = visible
    },
  },
}
</script>

<style lang='less' scoped>
@import '~@/assets/less/common.less';

/deep/ .ant-input {
  text-align: center;
}
</style>